import Select from 'react-select';
import classNames from 'classnames';

const DesignSelect = ({ className, ...props }: any) => (
  <Select
    name="courierIds"
    className={`mt-2 rounded-sm ${className}`}
    classNames={{
      container: () =>
        classNames(
          'outline outline-1 hover:outline-design-red active:outline-design-red',
        ),
      placeholder: () => classNames('dark:text-white'),
      singleValue: () => classNames('dark:bg-design-black dark:text-white'),
      input: () => classNames('dark:text-white'),
      control: () => classNames('dark:bg-design-black  !border-0 !shadow-none'),
      menu: () => classNames('dark:!bg-design-black !bg-white'),
      option: () =>
        classNames(
          '!bg-white dark:!text-white dark:!bg-design-black !text-design-black !dark:text-white  hover:!bg-light-gray  hover:dark:!bg-design-black-accent ',
        ),
    }}
    {...props}
  />
);

export default DesignSelect;
